import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token"); // Replace with your actual Bearer Token
const user = JSON.parse(localStorage.getItem("user"));
// const baseUrl = "http://localhost:8081/api";
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json", // Assuming you're sending JSON data
};

const Shopkeeper = {
  getAll: () =>
    axios.get(`${baseUrl}/shopkeepers/?branchId=${user.branchId}`, {
      headers: headers,
    }),
  getRents: (shopkeeperId) =>
    axios.get(
      `${baseUrl}/general-journals/received-payments-by-shopkeeper?shopkeeperId=${shopkeeperId}`
    ),
  getShops: (shopkeeperId) =>
    axios.get(
      `${baseUrl}/shop-contracts/shopkeeper-shops-history?shopkeeperId=${shopkeeperId}`
    ),
  getOne: (shopkeeperId) => axios.get(`${baseUrl}/shopkeepers/${shopkeeperId}`),
  add: (data) =>
    axios.post(`${baseUrl}/shopkeepers`, data, {
      headers: headers,
    }),

  update: (data) =>
    axios.put(`${baseUrl}/shopkeepers/?branchId=${user.branchId}`, data, {
      headers: headers,
    }),

  remove: (id) =>
    axios.delete(`${baseUrl}/shopkeepers/${id}`, { headers: headers }),
};

export default Shopkeeper;
